import React from 'react';
import { cn } from '../../utils';

export const Tabs = ({ value, onValueChange, children, className }) => (
    <div className={cn('flex flex-col gap-8', className)}>
        {React.Children.map(children, (child) =>
            React.isValidElement(child)
                ? React.cloneElement(child, { activeTab: value, onValueChange })
                : child
        )}
    </div>
);

export const TabsList = ({ activeTab, onValueChange, children, className }) => (
    <div role="tablist" className={cn('flex gap-1 border-b border-slate-200', className)}>
        {React.Children.map(children, (child) =>
            React.isValidElement(child)
                ? React.cloneElement(child, { activeTab, onValueChange })
                : child
        )}
    </div>
);

export const TabsTrigger = ({ activeTab, onValueChange, value, children, className }) => {
    const isActive = activeTab === value;

    return (
        <button
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onValueChange(value)}
            className={cn(
                'relative px-4 py-2.5 text-sm font-medium transition-colors -mb-px',
                isActive
                    ? 'text-yavrio-blue border-b-2 border-yavrio-blue'
                    : 'text-slate-500 hover:text-slate-700 border-b-2 border-transparent',
                className
            )}
        >
            {children}
        </button>
    );
};

export const TabsContent = ({ activeTab, value, children, className }) => {
    if (value !== activeTab) return null;

    return (
        <div role="tabpanel" className={cn('flex flex-col gap-8', className)}>
            {children}
        </div>
    );
};
